import React from "react";
import BusinessHubHeader from "../components/BusinessHubHeader.js";
import BusinessHubNavigation from "../components/BusinessHubNavigation.js";
import ProductCatalog from "../components/ProductCatalog.js";
import "../styles/ProductSubmission.css";

function ProductCatalogPage() {
  return (
    <div className="productSubmission-screen">
      <div className="productSubmission-header-container">
        <BusinessHubHeader />
      </div>
      <div className="productSubmission-page-content-container">
        <div className="business-hubb-navigator-sidebar">
          <BusinessHubNavigation mode="prod" active="D" />
        </div>
        <div className="productSubmission-content-container">
          <div className="productSubmission-content-card">
            <ProductCatalog />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductCatalogPage;
